import BooleanInputBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/BooleanInputBuilder';

type Props = {
  value: boolean | undefined;
  onChange: (value: boolean) => void;
};

export const EnableRTLTextConfig = ({ value, onChange }: Props) => {
  return (
    <div className="flex flex-col gap-2 gap-2">
      <BooleanInputBuilder
        name={'Enable Right-to-Left Text'}
        existingValue={!!value}
        updateProperty={onChange}
      />
      <div className="prose text-sm italic ml-8">
        If enabled, the content of this step will have right-to-left direction. This is necessary
        for languages that are written from right to left (e.g Arabic).
      </div>
    </div>
  );
};

export default EnableRTLTextConfig;
